package com.daytimegaming.ourdailyfinances.presentation.components

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Tune
import androidx.compose.material3.Badge
import androidx.compose.material3.BadgedBox
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
fun BadgedActionButton(
    modifier: Modifier = Modifier,
    onClick: () -> Unit,
    showWarningBadge: Boolean = false,
) {
    IconButton(
        modifier = modifier,
        onClick = onClick
    ) {
        val iconComposable = @Composable {
            Icon(
                imageVector = Icons.Default.Tune,
                contentDescription = "Manage Accounts",
                tint = MaterialTheme.colorScheme.onSurfaceVariant
            )
        }
        if (showWarningBadge) {
            BadgedBox(
                badge = {
                    Badge(containerColor = MaterialTheme.colorScheme.error) {
                        Text(text = "!")
                    }
                }
            ) {
                iconComposable()
            }
        } else {
            iconComposable()
        }
    }
}